var React = require('react');

function TimeIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M9 0C4.03748 0 0 4.03748 0 9C0 13.9625 4.03748 18 9 18C13.9625 18 18 13.9625 18 9C18 4.03748 13.9625 0 9 0ZM9 17.143C4.51015 17.143 0.85703 13.4902 0.85703 9C0.85703 4.50981 4.50981 0.85703 9 0.85703C13.4902 0.85703 17.143 4.50981 17.143 9C17.143 13.4902 13.4902 17.143 9 17.143Z","fill":"#A0A0A0","key":0}),React.createElement("path",{"d":"M4.92791 8.39294H8.68964V2.67862C8.68964 2.44191 8.88155 2.25 9.11826 2.25C9.35497 2.25 9.54688 2.44191 9.54688 2.67862V8.82128C9.54688 9.05799 9.35497 9.2499 9.11826 9.2499H4.92785C4.69114 9.2499 4.49923 9.05799 4.49923 8.82128C4.49923 8.58457 4.69114 8.39267 4.92785 8.39267L4.92791 8.39294Z","fill":"#A0A0A0","key":1})]);
}

TimeIcon.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = TimeIcon;

TimeIcon.default = TimeIcon;
